import { SearchItemType } from "../StoreSearchInput/storeSearchInput.types";

export const STORE_LOCATOR_MOBILE_MESSAGE_ID = "store-picker-error";

export const STORE_LOCATOR_MOBILE_INPUT_TYPES = new Map<SearchItemType, number>(
    [
        [SearchItemType.Store, 2],
        [SearchItemType.Locality, 3]
    ]
);
